import { useState, useCallback, useMemo } from 'react';

// Constante UUID regex
export const UUID_V4_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * Hook personalizado para manejar campos UUID con validación
 * @param {string} initialValue - Valor inicial del campo
 * @param {boolean} isOptional - Si el campo es opcional (válido cuando está vacío)
 * @returns {object} - Objeto con value, isValid, handleChange, reset
 */
export const useUuidField = (initialValue = '', isOptional = false) => {
  const [value, setValue] = useState(initialValue);

  const isValid = useMemo(() => {
    if (isOptional && value.trim() === '') return true;
    return UUID_V4_REGEX.test(value);
  }, [value, isOptional]);

  const handleChange = useCallback((e) => {
    setValue(e.target.value);
  }, []);

  const reset = useCallback(() => {
    setValue(initialValue);
  }, [initialValue]);

  return {
    value,
    isValid,
    handleChange,
    reset,
    isEmpty: value.trim() === '',
  };
};

/**
 * Hook para manejar la validación del formulario completo
 * @param {object} movementField - Campo movement ID
 * @param {object} batchField - Campo batch ID  
 * @returns {boolean} - Si el formulario es válido
 */
export const useFormValidation = (movementField, batchField) => {
  return useMemo(() => {
    const hasValidMovement = !movementField.isEmpty && movementField.isValid;
    const hasValidBatch = !batchField.isEmpty && batchField.isValid;
    
    // Al menos uno debe estar lleno y válido, y ambos deben ser válidos individualmente
    return (hasValidMovement || hasValidBatch) && movementField.isValid && batchField.isValid;
  }, [movementField.isEmpty, movementField.isValid, batchField.isEmpty, batchField.isValid]);
};
